import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import handleOpenApp from "../Utility/HandleOpenApp";
import plan2benefitLogo from "../../assets/plan2benefit_logo.png";

/* ─────────────────────────────────────────────────────────────
   Navbar (Car Version) — logo only, no nav links. The Car Plan
   page is a single scroll with one job, so the header stays to
   just the brand mark on the left and the one CTA that matters
   on the right.

   Hidden for the whole Hero section — the cinematic 3D reveal owns
   the screen with nothing competing for attention — and slides/
   fades in only once the user has scrolled past it (tracked via
   #hero's own bounding box, see `pastHero` below).
───────────────────────────────────────────────────────────── */
export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [pastHero, setPastHero] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const onScroll = () => {
      setScrolled(window.scrollY > 12);
      // getBoundingClientRect() reports the hero's real on-screen position
      // even though GSAP ScrollSmoother moves content via a transform
      // rather than the native scrollbar, so this stays accurate regardless
      // of how the scroll is actually driven.
      const heroEl = document.getElementById("hero");
      setPastHero(heroEl ? heroEl.getBoundingClientRect().bottom <= 0 : true);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "border-b border-[#eceafb] bg-white/80 backdrop-blur-xl"
          : "border-b border-transparent bg-white"
      }`}
      style={{
        willChange: "transform, opacity",
        transform: pastHero ? "translateY(0) translateZ(0)" : "translateY(-100%) translateZ(0)",
        opacity: pastHero ? 1 : 0,
        pointerEvents: pastHero ? "auto" : "none",
      }}
    >
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between gap-4 px-4 sm:px-6 lg:px-8">
        <img
          src={plan2benefitLogo}
          alt="Plan2Benefit"
          className="h-9 w-auto sm:h-10"
        />

        <button
          onClick={() => handleOpenApp()}
          className="group inline-flex items-center gap-2 rounded-full bg-[#4328E7] px-5 py-2.5 font-montserrat text-[13px] font-bold tracking-[-0.01em] text-white shadow-[0_1px_2px_rgba(0,0,0,0.10),0_10px_24px_-10px_rgba(0,0,0,0.15)] transition duration-300 md:hover:-translate-y-0.5 md:hover:bg-[#3520b8] md:hover:shadow-[0_2px_4px_rgba(0,0,0,0.12),0_16px_32px_-12px_rgba(0,0,0,0.16)]"
        >
          <span className="sm:hidden">Start</span>
          <span className="hidden sm:inline">Start My Car Plan</span>
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
        </button>
      </div>
    </header>
  );
}
